import { mergeAttributes, Node, ReactNodeViewRenderer } from "@tiptap/react"

import { MarkdownNodeComponent } from "./Component"

export const MarkdownNode = Node.create({
	name: "MarkdownNode",
	group: "block",
	addAttributes() {
		return {
			markdown: {
				isRequired: false,
			},
		}
	},
	parseHTML() {
		return [
			{
				tag: "markdown-node",
			},
		]
	},
	renderHTML({ HTMLAttributes }) {
		return ["markdown-node", mergeAttributes(HTMLAttributes)]
	},
	addNodeView() {
		return ReactNodeViewRenderer(MarkdownNodeComponent)
	},
})
